if (!customElements.get("alohas-focus-carousel")) {
  class AlohasFocusCarousel extends HTMLElement {
    //desktop properties
    actualPage = 0;
    prevPage = 0;
    nextPage = 0;
    initiated = false

    productsClassToShowArray = [];

    //mobile properties
    banners = [];
    lastBannerShown = null;

    constructor() {
      super();

      if (window.matchMedia("(max-width: 767px)").matches) {
        this.initMobile();
      } else {
        this.initDesktop();
      }
    }

    initDesktop() {
      //elements
      this.leftArrow = this.querySelector(".ff-arrow_left");
      this.rightArrow = this.querySelector(".ff-arrow_right");

      this.querySelectorAll(".ff-product-name").forEach((el) => {
        this.productsClassToShowArray.push(el.dataset.classToShowProduct);
      });

      if (this.productsClassToShowArray.length > 0) {
        // The carousel must already have the class of the first product to skip animation on initialization
        this.navigateToPage(0);
        this.leftArrow.addEventListener("click", this.leftClick.bind(this));
        this.rightArrow.addEventListener("click", this.rightClick.bind(this));
        this.initiated = true
      }
    }

    initMobile() {
      this.scrollContainer = this.querySelector(".ff-products-carousel");

      this.querySelectorAll(".ff-product-card").forEach((card, i) => {
        const productBanner = {
          classToShow: card.dataset.classToShowProduct,
          scrollLeft: card.clientWidth * i,
        };
        this.banners.push(productBanner);
      });

      if (this.scrollContainer && this.banners.length > 0) {
        this.classList.add(this.banners[0].classToShow);

        this.scrollContainer.addEventListener("scroll", () => {
          let closestBanner = this.banners[0];

          this.banners.forEach((banner) => {
            //set closest banner
            const currentDiff = Math.abs(
              this.scrollContainer.scrollLeft - banner.scrollLeft
            );
            const lastClosestDiff = Math.abs(
              this.scrollContainer.scrollLeft - closestBanner.scrollLeft
            );

            if (currentDiff < lastClosestDiff) closestBanner = banner;
          }, this);

          if (closestBanner.scrollLeft != this.lastBannerShown?.scrollLeft) {
            if (this.lastBannerShown) {
              this.setAttribute(
                "data-previous-product",
                this.lastBannerShown.classToShow
              );
              if (
                this.querySelector(
                  `[data-video="${this.lastBannerShown.classToShow}"]`
                )
              ) {
                this.querySelector(
                  `[data-video="${this.lastBannerShown.classToShow}"]`
                ).style.display = "none";
              }
            }

            if (
              this.querySelector(`[data-video="${closestBanner.classToShow}"]`)
            ) {
              this.querySelector(
                `[data-video="${closestBanner.classToShow}"]`
              ).style.display = "";
            }

            this.lastBannerShown = closestBanner;
            this.banners.forEach(({ classToShow }) =>
              this.classList.remove(classToShow)
            );
            this.classList.add(closestBanner.classToShow);
          }
        });
      }
    }

    navigateToPage(pageNum) {
      if (this.initiated) 
        this.classList.remove("ff-no-transition");

      // elements have an absolute position, so first we stablish which to show and when before starting their animations.
      this.setLayoutsOrder(pageNum);

      this.actualPage = pageNum;
      this.nextPage = this.actualPage + 1;
      this.prevPage = this.actualPage - 1;

      // animations of banners and cards depend on the class of this custom element and its data attributes
      this.productsClassToShowArray.forEach(
        (classToShow) => this.classList.remove(classToShow),
        this
      );
      this.classList.add(this.productsClassToShowArray[this.actualPage]);

      this.rightArrow.disabled = false;
      this.leftArrow.disabled = false;
    }

    /**
     * setup before start animations and move to next page
     */
    setLayoutsOrder(pageNum) {
      if (pageNum != this.actualPage) {
        this.setAttribute(
          "data-previous-product",
          this.productsClassToShowArray[this.actualPage]
        );
      }
      this.setAttribute(
        "data-products-next",
        this.productsClassToShowArray.slice(pageNum + 1).join(",")
      );

      if (pageNum > this.actualPage) {
        // configs animation for switching to the next product
        this.setAttribute(
          "data-accelerate-product-aparition",
          this.productsClassToShowArray[pageNum]
        );

        this.classList.add("going-right");
        this.classList.remove("going-left");
      } else {
        this.classList.remove("going-right");
        this.classList.add("going-left");
      }
    }

    leftClick() {
      if (this.actualPage === 0) {
        this.navigateToPage(this.productsClassToShowArray.length - 1);
      } else {
        this.navigateToPage(this.prevPage);
      }
    }

    rightClick() {
      if (this.actualPage === this.productsClassToShowArray.length - 1) {
        this.navigateToPage(0);
      } else {
        this.navigateToPage(this.nextPage);
      }
    }
  }

  customElements.define("alohas-focus-carousel", AlohasFocusCarousel);
}